import _ from 'lodash';

import { sexOptions as sexOptionsArray } from 'common-src/models/Patient';

export const sexOptions = _.map(sexOptionsArray, (option) => ({ value: option, label: option }));
